import { render, staticRenderFns } from "./report_list.vue?vue&type=template&id=10b0d7a1&scoped=true&"
import script from "./report_list.vue?vue&type=script&lang=js&"
export * from "./report_list.vue?vue&type=script&lang=js&"
import style0 from "./report_list.vue?vue&type=style&index=0&id=10b0d7a1&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0d7a1",
  null
  
)

export default component.exports